
(function() {
    var DISMISSED_KEY = 'tl_dismissed_gift_rules';

    function getDismissedRules() {
        try {
            return JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || '[]');
        } catch (e) {
            return [];
        }
    }

    function addDismissedRule(ruleId) {
        if (!ruleId) return;
        try {
            var rules = getDismissedRules();
            var strId = String(ruleId);
            if (rules.indexOf(strId) === -1) {
                rules.push(strId);
                sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(rules));
            }
        } catch (e) {}
    }

    function removeDismissedRule(ruleId) {
        if (!ruleId) return;
        try {
            var rules = getDismissedRules();
            var strId = String(ruleId);
            var index = rules.indexOf(strId);
            if (index !== -1) {
                rules.splice(index, 1);
                sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(rules));
            }
        } catch (e) {}
    }

    try {
        var originalFetch = window.fetch;
        if (originalFetch) {
            window.fetch = async function(resource, config) {
                var url = typeof resource === 'string' ? resource : (resource && resource.url) ? resource.url : '';
                var isCartChange = url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1;

                if (isCartChange) {
                    try {
                        if (window.tlFreeGiftOffer && window.tlFreeGiftOffer.ajaxApi && typeof window.tlFreeGiftOffer.ajaxApi.cartGet === 'function') {
                            const cart = await window.tlFreeGiftOffer.ajaxApi.cartGet();
                            if (cart && cart.items) {
                                window._salepifyGiftsBeforeUpdate = cart.items
                                    .map(function(item) {
                                        return {
                                            ruleId: window.tlFreeGiftOffer.checkLineItemIsGift(item)
                                        };
                                    })
                                    .filter(function(g) { return g.ruleId; });
                            }
                        }
                    } catch (e) {}
                }

                var response = await originalFetch.apply(this, arguments);

                if (isCartChange) {
                    try {
                        if (window.tlFreeGiftOffer && window._salepifyGiftsBeforeUpdate && window._salepifyGiftsBeforeUpdate.length) {
                            var updatedCartRes = response.clone();
                            var updatedCart = await updatedCartRes.json();
                            if (updatedCart && updatedCart.items) {
                                var currentGiftRuleIds = new Set(
                                    updatedCart.items
                                        .map(function(item) { return window.tlFreeGiftOffer.checkLineItemIsGift(item); })
                                        .filter(Boolean)
                                        .map(String)
                                );

                                (window._salepifyGiftsBeforeUpdate || []).forEach(function(oldGift) {
                                    if (oldGift.ruleId && !currentGiftRuleIds.has(String(oldGift.ruleId))) {
                                        addDismissedRule(oldGift.ruleId);
                                    }
                                });
                            }
                        }
                    } catch (e) {}
                }

                return response;
            };
        }
    } catch (e) {}

    try {
        var patchInterval = setInterval(function() {
            try {
                if (window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.checkRuleCondition === 'function') {
                    if (!window.tlFreeGiftOffer.checkRuleCondition._dismissPatched) {
                        var originalCheckRuleCondition = window.tlFreeGiftOffer.checkRuleCondition;
                        
                        window.tlFreeGiftOffer.checkRuleCondition = async function(rule, isStopped) {
                            try {
                                var res = await originalCheckRuleCondition.apply(this, arguments);
                                if (res && rule) {
                                    // TỰ ĐỘNG RESET: Nếu không còn sản phẩm mua đủ điều kiện (canClaimCount === 0), gỡ cờ chặn
                                    if (res.canClaimCount === 0) {
                                        removeDismissedRule(rule.id);
                                    } else {
                                        var dismissedList = getDismissedRules();
                                        if (dismissedList.indexOf(String(rule.id)) !== -1) {
                                            res.needToAdd = false;
                                            res.giftsToAdd = [];
                                        }
                                    }
                                }
                                return res;
                            } catch (e) {
                                return originalCheckRuleCondition.apply(this, arguments);
                            }
                        };
                        window.tlFreeGiftOffer.checkRuleCondition._dismissPatched = true;
                    }
                    clearInterval(patchInterval);
                }
            } catch (e) {}
        }, 100);

        setTimeout(function() {
            try { clearInterval(patchInterval); } catch (e) {}
        }, 10000);
    } catch (e) {}
})();
